import {makeAutoObservable} from 'mobx'

class LookAround {
    list = [];
    PAGE_SIZE = 6;
    pageSize = this.PAGE_SIZE;
    pageNum = 1;
    loading = false;

    constructor() {
        makeAutoObservable(this)
    }
}

class HomeStore {
    topBannerList = [];
    advList1 = [];
    swiperList1 = [];
    seckillList = [];
    newsList = [];
    categoryFloorList = [];
    recommendList = [];
    lookAround = new LookAround();

    constructor() {
        makeAutoObservable(this)
    }

    modifyGoodsFloorList(floor) {
        const innerFloorList = [...this.categoryFloorList];
        for (let i = 0; i < innerFloorList.length; i++) {
            if (innerFloorList[i].id === floor.id) {
                innerFloorList[i] = {...innerFloorList[i],...floor};
            }
        }

        this.categoryFloorList = innerFloorList;
    }

}

const store = new HomeStore()

export default store
